import { useMemo } from 'react'

import { SearchPublicOrganizationsQuery } from 'types/graphql'

import { useQuery } from 'src/utils/queryClient'

const SearchPublicOrganizations = gql`
  query SearchPublicOrganizationsQuery {
    organizations {
      id
      slug
      displayName
      city
      state
      isHidden
    }
  }
`

export const useSearchOrganizationsQuery = (searchQuery: string) => {
  const { data, ...rest } = useQuery<SearchPublicOrganizationsQuery>({
    queryKey: ['CitizenAI', 'searchOrgs', searchQuery],
    queryDocument: SearchPublicOrganizations,
    enabled: searchQuery.length >= 2,
  })

  const organizations = useMemo(() => {
    if (!data?.organizations) {
      return []
    }

    const query = searchQuery.toLowerCase()
    return data.organizations
      .filter((org) => {
        if (org.isHidden) {
          return false
        }
        const displayName = (org.displayName ?? org.city).toLowerCase()
        const city = org.city.toLowerCase()
        return displayName.includes(query) || city.includes(query)
      })
      .map((org) => ({
        slug: org.slug,
        displayName: org.displayName ?? org.city,
        state: org.state,
      }))
      .slice(0, 10)
  }, [data, searchQuery])

  return {
    ...rest,
    organizations,
  }
}
